<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <div class="d-flex flex-row align-center">
        <h1 class="section-header__title mb-0">
          Одобрение аккредитаций
        </h1>
        <v-btn icon @click="loadFile" :loading="loadingFile">
          <v-icon color="success" size="24">mdi-microsoft-excel</v-icon>
        </v-btn>
      </div>
      <div class="d-flex flex-row align-start">
        <v-icon
          size="20"
          color="info"
          class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
          v-model.lazy="search"
          color="info"
          outlined
          label="Начните набирать наименование организации"
          class="search-field"
          dense
          style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <GridTable
        :data-rows="showingServerData"
        :rewrite-headers="rwrw"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingData"
        :num-cols="headers.countCells"
        ref="npg-table"
        key="form-5-06"
      >
        <template #org="{row}">
          <template v-if="row.uslName">
            <div class="font-weight-bold font-size-medium ">
              {{ row.uslName[0].toUpperCase() + row.uslName.slice(1) }}
            </div>
          </template>
          <template v-else>
            <div class="pl-2" style="min-width: 40px">
              {{ row.orgId }}
            </div>
            <div class="ml-0">
              {{ row.orgName }}
            </div>
          </template>
        </template>
        <template #npg="{row}">
          <template v-if="!row.uslName">
            <div style="">
              {{ row.kcpGroup.code }}
            </div>
            <div class="ml-3">
              {{ row.kcpGroup.name }}
            </div>
          </template>
        </template>
        <template #hasAccred="{row}">
          {{ row.hasAccred ? 'да' : 'нет' }}
        </template>
        <template #hasLicense="{row}">
          {{ row.hasLicense ? 'да' : 'нет' }}
        </template>
        <template #kcpList="{row}">
          <template v-if="parseKcpList(row.kcpList, 1)">
            <div v-for="item in parseKcpList(row.kcpList, 1)" :key="item.year" class="d-flex flex-nowrap text-no-wrap">
              {{ item.year }} год - {{ item.value }}
            </div>
          </template>
          <div v-else></div>
        </template>
        <template #kcpList1="{row}">
          <template v-if="parseKcpList(row.kcpList, 2)">
            <div v-for="item in parseKcpList(row.kcpList, 2)" :key="item.year" class="d-flex flex-nowrap text-no-wrap">
              {{ item.year }} год - {{ item.value }}
            </div>
          </template>
          <div v-else></div>
        </template>
        <template #kcpList2="{row}">
          <template v-if="parseKcpList(row.kcpList, 3)">
            <div v-for="item in parseKcpList(row.kcpList, 3)" :key="item.year" class="d-flex flex-nowrap text-no-wrap">
              {{ item.year }} год - {{ item.value }}
            </div>
          </template>
          <div v-else></div>
        </template>
        
        <template #hasGa2019="{row}">
          <div>
            2020 год - {{ parseGaList(row.hasGa2019) }}
          </div>
          <div>
            2021 год - {{ parseGaList(row.hasGa2020) }}
          </div>
          <div>
            2022 год - {{ parseGaList(row.hasGa2021) }}
          </div>
          <div>
            2023 год - {{ parseGaList(row.hasGa2022) }}
          </div>
        </template>
        <template #actions="{row}">
          <div class="d-flex flex-row">
            <v-btn
              :disabled="isBlocked"
              :loading="loadingMenu.id ===row.id && loadingMenu.value === true"
              icon
              @click="changeStatus(row, true)"
            >
              
              <v-icon color="success" size="18">mdi-check</v-icon>
            </v-btn>
            <v-btn
              :disabled="isBlocked"
              :loading="loadingMenu.id ===row.id && loadingMenu.value === true"
              class=""
              icon
              @click="changeStatus(row, false)"
            >
              <v-icon color="error" size="18">mdi-close</v-icon>
            </v-btn>
          </div>
        </template>
      </GridTable>
      <div class="mt-3 d-flex flex-row justify-center align-center">
        <v-autocomplete
          class="pagination-table"
          v-model="userPages"
          :items="pagesPaginate"
          solo
          dense
          filled
          height="25"
          rounded
          style="max-width: 150px"
          @change="changePage($event)"
        ></v-autocomplete>
        <v-pagination
          v-model="page"
          :length="pagesVuetify"
          :total-visible="7"
          @input="changePage($event)"
        >
        </v-pagination>
      </div>
    </wrapper-preview-category>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import GridTable from "@/components/GridTable/GridTable";
import accreditationApproved from "@/pages/Founders/configs/accreditationApproved";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import {tablePagination} from "@/mixins/tablePagination";
import {mapGetters} from "vuex";
import FounderController from "@/controllers/Founders/FounderController";

export default {
  name: "AccreditationAgreed",
  mixins: [headerTooltipFunctions, tablePagination],
  components: {GridTable, WrapperPreviewCategory},
  data() {
    return {
      serverDataBeforeFilter: [],
      loadingData: false,
      changingHeaders: false,
      loadingFile: false,
      searchOrg: '',
      search: '',
      searchFields: [
        {text: 'ID', value: 'sprOrgId'},
        {text: 'Наименование', value: 'orgName'},
      ],
      selectedSearchField: 'orgName',
      headers: accreditationApproved,
      loadingMenu: {value: false, id: ''},
      full: false,
      rwrw: false
    }
  },
  computed: {
    ...mapGetters('spr', {
      get_spr_data_usl_loading: 'getUslsStatus',
    }),
    isBlocked() {
      return false;
    },
    serverData() {
      return this.serverDataBeforeFilter
        .filter(el => !this.search || el.uslName || el.orgName.toLowerCase().search(this.search.toLowerCase()) !== -1 || String(el.orgId).toLowerCase().search(this.search.toLowerCase()) !== -1)
      
    },
    headersForRows() {
      return this.headers.massive.filter(el => el.variable).sort((a, b) => a.order - b.order).map(el => {
        return {
          ...el,
          styles: (row) => {
            const color = row.flApproved ? 'background-color: #EBF9EB; color: #29A128;' : row.flApproved === false ? 'color: #ED393E; background-color: #FDEBEB;' : '';
            if (el.dataField !== 'org')
              return row.uslName ? `${color} display: none!important;` : `${color} justify-content: unset; text-align: center; `
            else
              return `${color}`
          },
          rowsDataCalc: () => 1,
          colsDataCalc: (row) => {
            if (el.dataField !== 'org')
              return el.cols;
            else
              return row.uslName ? this.headers.countCells : el.cols;
          },
          props: (row, cell, loading) => {
            return {
              value: row[cell.dataField],
              title: '',
              cell: cell,
              id: row.id,
              row: row,
              loading: loading,
            }
          }
        }
      })
    },
  },
  created() {
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    get_spr_data_usl_loading() {
      this.loadingDataTable();
    }
  },
  methods: {
    parseKcpList(arr, foId) {
      if (!arr || arr.length === 0)
        return null;
      const res = arr.filter(el => el.foId === foId);
      if (!res || res.length === 0)
        return null;
      return res
    },
    async changeStatus(row, flag) {
      console.log(row, flag);
      this.loadingMenu = {value: true, id: row.id}
      try {
        const res = await FounderController.resolveRejectOffer(row.id, flag);
        if (res) {
          const changedObj = this.serverDataBeforeFilter.findIndex(el => el.id === row.id);
          this.serverDataBeforeFilter.splice(changedObj, 1, res);
        }
        this.loadingMenu = {value: false, id: row.id}
      } catch (e) {
        this.loadingMenu = {value: false, id: row.id}
      }
    },
    loadingDataTable() {
      this.loadingData = true;
      FounderController.getForm2()
        .then(data => this.serverDataBeforeFilter = data)
        .finally(() => this.loadingData = false)
    },
    loadFile() {
      this.loadingFile = true;
      FounderController.getExcel()
        .finally(() => this.loadingFile = false);
    },
    parseGaList(value) {
      return value ? 'есть' : value === null ? 'н.д.' : 'нет';
    },
  },
}
</script>

<style scoped>

</style>